const TIERS = {
  ESSENTIALS: 'essentials',
  PREMIUM: 'premium',
  OFFICE_PREMIUM: 'office premium',
  STANDARD: 'standard',
  ULTIMATE: 'ultimate',
  ENTERPRISE: 'enterprise',
};

export const BRAND_TIER_FEATURES = {
  HIPAA_COMPLIANCE: 'hipaa compliance',
  SINGLE_SIGN_ON: 'single sign-on',
  ACTIVE_DIRECTORY: 'active directory integration',
  CNAM: 'outbound cnam',
  UNLIMITED_SITES: 'unlimited sites',
};

export const BRAND_TIER_RULESET = {
  ringcentral: {
    [TIERS.ESSENTIALS]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: false,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: false,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.STANDARD]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: true,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: false,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: false,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.PREMIUM]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: true,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: true,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.OFFICE_PREMIUM]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: true,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: true,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.ULTIMATE]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: true,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: true,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.ENTERPRISE]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: true,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: true,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
  },
  'ringcentral uk': {
    [TIERS.ESSENTIALS]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: false,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.STANDARD]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: false,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.PREMIUM]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.OFFICE_PREMIUM]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.ULTIMATE]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.ENTERPRISE]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
  },
  'ringcentral eu': {
    [TIERS.STANDARD]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: false,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.PREMIUM]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.OFFICE_PREMIUM]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.ULTIMATE]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.ENTERPRISE]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
  },
  'ringcentral au': {
    [TIERS.ESSENTIALS]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: false,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.STANDARD]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: false,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.PREMIUM]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.OFFICE_PREMIUM]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.ULTIMATE]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
    [TIERS.ENTERPRISE]: {
      [BRAND_TIER_FEATURES.HIPAA_COMPLIANCE]: false,
      [BRAND_TIER_FEATURES.SINGLE_SIGN_ON]: true,
      [BRAND_TIER_FEATURES.ACTIVE_DIRECTORY]: true,
      [BRAND_TIER_FEATURES.CNAM]: false,
      [BRAND_TIER_FEATURES.UNLIMITED_SITES]: true,
    },
  },
};
